import { Component, OnInit } from '@angular/core';
import { UserDataService } from '../../data-storage/user-data.service';
import { Input } from '@angular/core';
import { UserService } from '../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Location } from '@angular/common';
import { GlobalDataService } from '../../../../shared-services/global-data.service';
import { UserDto } from '../../../../dtos/userDto';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SiteDto } from '../../../../dtos/siteDto';
import { SitesDataService } from '../../data-storage/sites-data.service';
import { switchMap } from 'rxjs/operators';
import { iif } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { SubscriptionPacketsService } from '../../services/subscription-packets.service';

@Component({
    selector: 'app-top-navigation',
    templateUrl: './top-navigation.component.html',
    styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent implements OnInit {

    constructor(private userDataService: UserDataService,
                private userService: UserService,
                public translate: TranslateService,
                public globalDataService: GlobalDataService,
                private router: Router, private location: Location,
                private sitesDataService: SitesDataService,
                private subscriptionPacketsService: SubscriptionPacketsService) {
    }

    $userCurrent: Observable<UserDto>;

    @Input()
    openLoginWindow: boolean;

    @Input()
    openSignUpWindow: boolean;

    @Input()
    isPacketOpen: boolean;

    @Output()
    isPacketOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input()
    siteId: number;

    dropDownLanguages = [
        {code: "el", value: "Ελληνικά"},
        {code: "en", value: "English"}
    ]

    siteIsBought$: Observable<boolean>;

    private subscription: Subscription;

    ngOnInit(): void {
        this.$userCurrent = this.userDataService.currentUser;
        this.siteIsBought$ = this.sitesDataService.getSiteById(this.siteId).pipe(
            switchMap((site) =>
                iif(() => site.free,
                    of(true),
                    of(this.subscriptionPacketsService.isSitePurchased(site))
                )
            )
        );
    }

    logout() {
        this.userService.logout();
        this.openSignUpWindow = false;
    }

    getActiveLang() {
        return this.dropDownLanguages.find((el) => el.code === this.translate.currentLang).value
    }

    setLanguage(lang) {
        let urlToGo = "";
        this.dropDownLanguages.forEach((language) => {
            if (this.router.url.includes(language.code)) {
                urlToGo = this.router.url.replace(language.code, lang.code);
            }
        })
        this.translate.use(lang.code);
        this.location.go(urlToGo);
    }

    openPacket() {
        this.isPacketOpenChange.emit(true);
    }

    signUp() {
        this.openSignUpWindow = true
    }

    login() {
        this.openLoginWindow = true
    }
}
